/*eslint-disable*/
// =======================================================
//                   Imports
// =======================================================
import { Box, Tooltip } from "@mui/material";
import FlatList from "flatlist-react";
import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

//import QRCode from 'qrcode';

import { handleExportPDF } from "../../components/ExportBrochure";

import { FirebaseContext } from "common";
import { language, STYLES } from "config";

import Material_React_Table from "../../components/Custom-React-Material-Table";
import ShareListingBrochureModal, { useShareModal } from "../../components/ShareListingBrochureModalWebApp";

// Import the PropertyProcessorForm component
import PropertyProcessorForm from "../../components/MaterialReactTableModals/PropertyProcessorForm"; // Add this import

// import { ExportBrochure } from "../../components/ExportBrochure"
import { Typography, Snackbar, Button as MuiButton } from "@material-ui/core";
import CustomAdvanceListingsFilter from "../../components/CustomAdvanceListingsFilter";

import { jsPDF } from "jspdf";

// import Image.png from "../../"

// import Image from "../../assets/api_images/API-logo-ligh-blue-back138x75.png";
// API-logo-ligh-blue-back138x75.png

import assets from "assets";

import {
  CardImg,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from "reactstrap";

import CircularLoading from "../../components/CircularLoading";

import ApiWebIcon from "web-app/src/assets/icons/button icons/API-website-button.png";
import ApiWebGrey from "web-app/src/assets/icons/button icons/API-website-button-over.png";
import OPIcon from "web-app/src/assets/icons/button icons/Office-Place-button.png";
import OPIconGrey from "web-app/src/assets/icons/button icons/Office-Place-button-over.png";
import PrivatePropertyIcon from "web-app/src/assets/icons/button icons/private-property-button.png";
import PrivatePropertyGreyIcon from "web-app/src/assets/icons/button icons/private-property-button-over.png";
import Property24Icon from "web-app/src/assets/icons/button icons/property-24-button.png";
import Property24GreyIcon from "web-app/src/assets/icons/button icons/property-24-button-over.png";
import BulletMenuIcon from "web-app/src/assets/icons/button icons/bullet-menu-icon.png";
import { duplicateListing } from "common/src/actions/Listingactions";

// =======================================================
//                    Styles
// =======================================================
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    gap: "20px"
  },
  filter: {
    width: "100%"
  },

  listingsContainer: {
    backgroundColor: "white",
    borderRadius: "4px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    width: "100%",
    display: "grid",
    gap: "1px",
    alignItems: "center",
    justifyContent: "center",
    gridTemplateColumns: "repeat(auto-fill, minmax(600px, 1fr))"
  },

  listingsTable: {
    backgroundColor: "white",
    borderRadius: "4px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    width: "100%",
    alignItems: "center",
    justifyContent: "center"
  },

  listingContainer: {
    gap: "10px",
    padding: "10px",
    backgroundColor: "white",
    margin: "10px 0",
    minHeight: "280px",
    width: "95%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 2,
    cursor: "pointer",
    borderColor: STYLES.PRIMARY_APP_CLR,
    borderStyle: "solid"
  },

  listingImageSections: {
    width: "50%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    flexDirection: "column"
  },

  listingImage: {
    height: "100%",
    width: "100%",
    aspectRatio: "16/9" // Set the aspect ratio to 1:1
  },

  imageBannar: {
    gap: "4px",
    backgroundColor: "rgba(22,22,22,0.8)",
    width: "100%",
    alignContent: "center",
    justifyContent: "center",
    display: "flex"
  },

  numberFont: {
    fontSize: 16,
    color: "white",
    marginLeft: 2
  },

  discriptionSection: {
    display: "flex",
    alignContent: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    width: "45%",
    height: "95%"
  }
};

const StaffListings = () => {
  //const declared for the screen
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  let displayType = location.state || null;
  let passedListings = location.state?.listings || null;



  const statusMapping = {
    // -------------------------------
    // Active on the market
    // -------------------------------
    Active: "active",
    NewListing: "active",
    BackOnMarket: "active",
    Extended: "active",
    RaisedPrice: "active",
    ReducedPrice: "active",
    ForSale: "active",
    ToLet: "active",

    // -------------------------------
    // Listed but not currently active / pending
    // -------------------------------
    PendingOffer: "warning",
    Pending: "warning",
    Rented: "warning",
    Withdrawn: "warning",
    CancelledSale: "warning",
    Expired: "warning",
    Cancelled: "warning",

    // -------------------------------
    // No longer available / closed / completed
    // -------------------------------
    Sold: "warning",
    Inactive: "warning",
    Archived: "warning",

    // -------------------------------
    // Fallback (optional)
    // -------------------------------
    Unknown: "error",
  };

  const renderStatusDisplay = (statusKey, isListed, error = null) => {
    const hasError = error;

    let statusCategory;

    if (hasError) {
      statusCategory = "error";
    } else if (!statusKey) {
      statusCategory = "notListed";
    } else if (isListed && !statusKey) {
      statusCategory = "noStatus";
    } else {
      statusCategory = statusMapping[statusKey] || "warning";
    }




    // Icon + color mapping
    const iconMap = {
      active: { icon: "✔", color: "#27ae60", title: "Active on market" },
      warning: { icon: "!", color: "#f39c12", title: "Listed but not active" },
      error: { icon: "!", color: "#e74c3c", title: "Error publishing" },
      notListed: { icon: "✖", color: "#e74c3c", title: "Not listed" }
    };


    const { icon, color, title } = iconMap[statusCategory];

    return <span style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 28,
      height: 28,
      borderRadius: "50%",
      background: color,
      color: "#fff",
      fontWeight: "bold",
      fontSize: 18
    }} title={`${title} (${statusKey})`}>{icon}</span>;
  };



  const columns = [
    {
      accessorKey: "address.description",
      header: "Address",
      size: 50
    },
    {
      accessorKey: "web_Ref_No",
      header: "Web Ref",
      Cell: ({ cell, row }) => (
        <a
          onClick={() => {
            navigate("/stockdetials", {
              state: { item: row.original }
            });
            //fetchAllListings();
          }}
          style={{ color: "#1976d2", textDecoration: "underline", cursor: "pointer" }}
        >
          {cell.getValue()}
        </a>
      ),
      size: 160
    },
    {
      accessorKey: "userdetials.Name",
      header: "Broker",
      Cell: ({ cell, row }) => (
        <span>{row.original.userdetials.Name} {" "} {row.original.userdetials.lastName}</span>
      ),
      size: 160
    },
    {
      accessorKey: "P24Status",
      header: "Property 24",
      Cell: ({ cell, row }) => (
        renderStatusDisplay(cell.getValue(), row.original.publishedProp24)
      ),
      size: 160
    },


    {
      accessorKey: "PPStatus",
      header: "Private Property",
      Cell: ({ cell, row }) => (
        renderStatusDisplay(cell.getValue(), row.original.publishedPP)
      ),
      size: 160
    },


    {
      accessorKey: "wsListingId",
      header: "Website",
      Cell: ({ cell, row }) => (
        renderStatusDisplay(cell.getValue())
      ),
      size: 160
    },

    {
      accessorKey: "CreatedAt",
      header: "Date Listed",

      Cell: ({ cell, row }) => (
        <span>{moment(cell.getValue()).format('YYYY-MM-DD HH:mm:ss')}</span>
      ),

      size: 160
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 160
    },
    {
      accessorKey: "office",
      header: "Branch",
      size: 160
    },

    {
      accessorKey: "type",
      header: "Listing Type",
      size: 50
    },
    {
      accessorKey: "typeOfProperty",
      header: "Property Type",
      size: 50
    },
    {
      header: "Price",
      size: 120,
      muiTableBodyCellProps: {
        align: "right"
      },
      Cell: ({ row }) => {
        const data = row.original; // ✅ full row object
        const value =
          data.type === "tolet" || data.type?.includes("To Let")
            ? "R" + numberWithSpaces(data.grossmonthlyRental)
            : "R" + numberWithSpaces(data.price);

        return value ? value.toLocaleString() : "-";
      }
    },
    {
      accessorKey: "gla",
      header: "Floor size",
      size: 50,
      muiTableBodyCellProps: {
        align: "right"
      }
    },
  ];

  //Reducers
  const listingManagementReducer = useSelector((state) => state.ListingData);

  //Actions Declared for the screen
  const { api } = useContext(FirebaseContext);
  const {
    CreateListing,
    clearListingErrors,
    UpdateListing,
    fetchAllListings,
    fetchCurrentAdminsBranchListings,
    uploadListingWithBrochure,
    fetchBroker,
    generatePdfLinks
  } = api;

  //useStates Decalred
  const [view, setView] = useState("table");
  const [currentListings, setCurrentListings] = useState([]);
  const [displayedListings, setDisplayedListings] = useState([]);
  const [loading, setLoading] = useState({ isloading: false, reason: "" });
  const [message, setMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [undoListing, setUndoListing] = useState(null);
  const [brochureOpen, setbrochureOpen] = useState(false);
  const [link, setLink] = useState(null);
  const [brokerInfo, setBrokerInfo] = useState(null);

  // Add state for Property Processor
  const [processorOpen, setProcessorOpen] = useState(false);
  const [processedData, setProcessedData] = useState([]);

  const theState = useSelector((state) => state);
  const allBrokers = useSelector((state) => state.brokers.users);
  const [filteredListings, setFilteredListings] = useState([])
  const [selectedListing, setSelectedListing] = useState();

  const {
    modalVisible,
    modalItem,
    modalResult,
    showModal,
    hideModal,
    clearResult
  } = useShareModal();
  /*=============================================
  =            Use Effects            =
  =============================================*/

  useEffect(() => {
    dispatch(clearListingErrors())
  }, []);

  useEffect(() => {
    if (modalResult) {
      console.log('User selected:', modalResult);

      // You can handle the result here
      switch (modalResult) {
        case 'address':
          const updatedItem = {
            ...modalItem, // Use modalItem from the hook
            locationType: 'address'
          };
          // Dispatch and wait for completion
          dispatch(UpdateListing(updatedItem)).then(() => {
            // Now the listing should be updated
            getBrochureLinks(updatedItem);
          });
          break;
        case 'suburb':
          const suburbItem = {
            ...modalItem,
            locationType: 'suburb'
          };
          // Dispatch and wait for completion
          dispatch(UpdateListing(suburbItem)).then(() => {
            // Now the listing should be updated
            getBrochureLinks(suburbItem);
          });
          break;
        case 'cancelled':
          setLoading({ isloading: false, reason: "" });
          break;
      }
    }
  }, [modalResult])

  useEffect(() => {
    if (listingManagementReducer?.pdfLinks) {
      setLink(listingManagementReducer?.pdfLinks);
      setLoading({ isloading: false, reason: "" });
    }

  }, [listingManagementReducer]);

  useEffect(() => {
    // Fetch all listings when the component mounts

    setCurrentListings([]);

    console.log("listingMan", listingManagementReducer);

    console.log("displayType", displayType);
    if (displayType === "Active") {
      setCurrentListings(listingManagementReducer.activeListingsByBranch);
    }

    if (displayType === "inActive") {
      setCurrentListings(listingManagementReducer.inactiveListingsByBranch);
    }

    if (displayType !== "Active" && displayType !== "inActive") {
      setCurrentListings([
        ...listingManagementReducer.activeListingsByBranch,
        ...listingManagementReducer.inactiveListingsByBranch
      ]);
    }

    if (Array.isArray(displayType)) {
      setCurrentListings(displayType)
    }

    console.log("state; ", theState);
  }, [listingManagementReducer.listing, displayType]);

  /*=============================================
  =            Functions block                  =
  =============================================*/

  //I dont know how this code works but i got chatgpt to make it and it works for all cases please take car well modifing

  const getBrochureLinks = async (item) => {
    setLoading({ isloading: true, reason: "Generating PDF..." });

    dispatch(generatePdfLinks(item.web_Ref_No))
  }

  function numberWithSpaces(input) {
    if (!input) return "";

    // Convert to string and keep digits and the first dot
    let cleaned = "";
    let dotFound = false;
    for (let char of input.toString()) {
      if (char >= "0" && char <= "9") {
        cleaned += char;
      } else if (char === "." && !dotFound) {
        cleaned += ".";
        dotFound = true;
      }
    }

    // Split into integer and decimal parts
    const [intPart, decimalPart] = cleaned.split(".");

    // Add spaces to the integer part
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    // Recombine
    return decimalPart ? `${formattedInt}.${decimalPart}` : formattedInt;
  }

  const changeListingToViewed = (item) => {
    dispatch(
      UpdateListing({
        ...item,
        viewedByAdmin: true
      })
    );
    dispatch(clearListingErrors());
    console.log("Updated");
  };

  const changeListingToNew = (item) => {
    dispatch(
      UpdateListing({
        ...item,
        viewedByAdmin: false
      })
    );
    dispatch(clearListingErrors());
    console.log("Updated");
  };

  const handleSnackbarClose = async () => {
    setSnackbarOpen(false);
    await dispatch(fetchCurrentAdminsBranchListings());
  };

  const handleUndo = async () => {
    if (!undoListing) return;
    setSnackbarOpen(false);
    await dispatch(
      UpdateListing({
        ...undoListing,
        status: displayType === "Active" ? "Active" : "Inactive",
        viewedByAdmin: true
      })
    );
    dispatch(fetchCurrentAdminsBranchListings());
    dispatch(clearListingErrors());
  };

  const UpdateBrochure = async (item) => {
    const blob = await handleExportPDF(item); // returns a blob
    console.log("Blob acquired:", blob);
    const response = await dispatch(uploadListingWithBrochure(item, blob));
    setLink(response);
    setLoading({ isloading: false, reason: "" });
    //  console.log("Response :", response)
    //  alert("Here is the brochure link: " + response);
    await dispatch(fetchAllListings());
  };

  const SyncWithWebsite = async (item) => {
    try {
      setLoading({ isLoading: true, reason: "Syncing with website" });

      await dispatch(UpdateListing({
        ...item,
        syndicateFlags: {
          ...item.syndicateFlags,
          website: true
        }
      }));

      await dispatch(fetchAllListings());
      dispatch(clearListingErrors());
    } catch (error) {
      console.error("Failed to sync with website:", error);
      // Optionally show an error message to the user here
      alert("Failed to sync with website:", error);
    } finally {
      setLoading({ isLoading: false, reason: "" });
    }
  };

  const SyncWithPrivateProperty = async (item) => {
    try {
      setLoading({ isLoading: true, reason: "Syncing with Private Property" });

      await dispatch(UpdateListing({
        ...item,
        syndicateFlags: {
          ...item.syndicateFlags,
          privateProperty: true
        }
      }));

      await dispatch(fetchAllListings());
      dispatch(clearListingErrors());
    } catch (error) {
      console.error("Failed to sync with private property:", error);
      // Optionally show an error message to the user here
      alert("Failed to sync with private property:", error);
    } finally {
      setLoading({ isLoading: false, reason: "" });
    }
  };

  const SyncWithProperty24 = async (item) => {
    try {
      setLoading({ isLoading: true, reason: "Syncing with Property24" });

      await dispatch(UpdateListing({
        ...item,
        syndicateFlags: {
          ...item.syndicateFlags,
          property24: true
        }
      }));

      await dispatch(fetchAllListings());
      dispatch(clearListingErrors());
    } catch (error) {
      console.error("Failed to sync with property24:", error);
      // Optionally show an error message to the user here
      alert("Failed to sync with property24:", error);
    } finally {
      setLoading({ isLoading: false, reason: "" });
    }
  };

  const Brochure = async (item) => {
    if (item.BrochureUrl) {
      setLink(item.BrochureUrl);
      setLoading({ isloading: false, reason: "" });
      // console.log("Url:", item.BrochureUrl);
      // alert("Here is the brochure link: " + item.BrochureUrl);
    } else {
      const blob = await handleExportPDF(item); // returns a blob
      console.log("Blob acquired:", blob);

      const response = await dispatch(uploadListingWithBrochure(item, blob));
      setLoading({ isloading: false, reason: "" });
      setLink(response);
      //  console.log("Response :", response)
      //  alert("Here is the brochure link: " + response);
      await dispatch(fetchAllListings());
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(link);
    setLink(null);
  };

  const isPublished = (listingItem) => {
    return !!listingItem?.startPublishing;
  };

  // Function to handle processed data from PropertyProcessorForm
  const handleProcessedData = (processedData) => {
    setProcessedData(processedData);
    // You can do something with the processed data here
    console.log("Processed data:", processedData);
  };

  /*=====    End of Functions block     ======*/

  const RenderItem = (item) => {
    const dropdownRef = useRef();
    const [dropUp, setDropUp] = useState(false);
    const onProperty24 = () => {
      window.open(
        `https://www.property24.com/for-sale/search?SearchText=${item?.ListingId}`,
        "_blank"
      );
    };
    const onPrivateProperty = () => {
      window.open(
        `https://www.privateproperty.co.za/commercial-rentals/western-cape/cape-town/matroosfontein/epping/14-gunners-circle/24-gunners-circle/RR4481821`,
        "_blank"
      );
    };
    const onAPIProperty = () => {
      window.open(
        `https://api-prop.plum.systems/index.php/properties#sort=attr.cat.frontend_value&sortdir=desc`,
        "_blank"
      );
    };

    useEffect(() => {
      // Function to check the distance between the bottom of the item and the bottom of the viewport
      const checkDropdownPosition = () => {
        if (dropdownRef.current) {
          const rect = dropdownRef.current.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          // Check if the bottom of the item is within 200px of the bottom of the viewport
          setDropUp(windowHeight - rect.bottom < 200);
        }
      };
      // Add event listeners for scroll and resize
      window.addEventListener("scroll", checkDropdownPosition);
      window.addEventListener("resize", checkDropdownPosition);
      checkDropdownPosition();
      // Cleanup function to remove event listeners
      return () => {
        window.removeEventListener("scroll", checkDropdownPosition);
        window.removeEventListener("resize", checkDropdownPosition);
      };
    }, []);

    return (
      <div style={styles.listingContainer} ref={dropdownRef}>
        <div
          onClick={() => {
            if (!item?.viewedByAdmin) {
              changeListingToViewed(item);
            }
            navigate("/stockdetials", {
              state: { item }
            });
          }}
          style={styles.listingImageSections}
        >
          <CardImg
            alt="Card image cap"
            lazyload="true"
            //src="https://picsum.photos/256/186"
            src={Object.values(item?.images ? item?.images : {})[0]}
            top
            style={styles.listingImage}
          />
          {item?.images ? (
            <div style={styles.imageBannar}>
              <i
                className="now-ui-icons design_image"
                style={{ color: "white", marginTop: 4, fontSize: 16 }}
              />
              <p style={styles.numberFont}>
                {" "}
                {Object.values(item?.images).length} Photos{" "}
              </p>
            </div>
          ) : null}
        </div>

        <div
          onClick={() => {
            if (!item?.viewedByAdmin) {
              changeListingToViewed(item);
            }
            navigate("/stockdetials", {
              state: { item }
            });
          }}
          style={styles.discriptionSection}
        >
          {/* Listing Card Heading */}

          <div>
            <span
              className="h4"
              style={{ color: STYLES.SECONDARY_APP_CLR, fontWeight: "bold" }}
            >
              R{" "}
              {numberWithSpaces(
                item?.type === "tolet" || item?.type.includes("To Let")
                  ? item.grossmonthlyRental
                  : item.price
              )}
            </span>
            <span className="h4" style={{ color: STYLES.SECONDARY_APP_CLR }}>
              {item?.type === "tolet" || item?.type.includes("To Let")
                ? " pm"
                : null}
            </span>{" "}
          </div>

          <div>
            <span
              style={{
                margin: "0px",
                color: STYLES.SECONDARY_APP_CLR,
                marginBottom: 4
              }}
            >
              <Typography
                variant="h6"
                style={{
                  color: STYLES.SECONDARY_APP_CLR,
                  textTransform: "none"
                }}
              >
                {numberWithSpaces(item?.gla)} ㎡ {item.typeOfProperty} to{" "}
                {item?.type === "tolet" || item?.type.includes("To Let")
                  ? "Rent"
                  : "Buy"}{" "}
                at {item?.address.description}
                {/* {item?.location} */}
              </Typography>
              <br />
            </span>

            <div
              style={{
                display: "flex",
                gap: "20px",
                color: STYLES.SECONDARY_APP_CLR
              }}
            >
              <div>
                <span
                  className="h6"
                  style={{
                    marginRight: 6,
                    fontWeight: "bold",
                    textTransform: "none"
                  }}
                >
                  Floor Size:
                </span>
                <span>
                  {item?.floorSize ? `${item.floorSize} ㎡` : "Unavailable"}
                </span>
              </div>

              <div>
                <span
                  className="h6"
                  style={{
                    marginRight: 6,
                    fontWeight: "bold",
                    textTransform: "none"
                  }}
                >
                  Land Size:
                </span>
                <span>
                  {item?.landSize ? `${item.landSize} ㎡` : "Unavailable"}
                </span>
              </div>
            </div>

            <div style={{ color: STYLES.SECONDARY_APP_CLR, margin: 0 }}>
              <span className="h6" style={{ textTransform: "none" }}>
                Web Ref No:
              </span>{" "}
              {item?.web_Ref_No && (
                <Tooltip
                  title={
                    <Box sx={{ p: 1, minWidth: 180 }}>
                      <div>
                        <b>Web Ref:</b> {item.web_Ref_No}
                      </div>
                      <div>
                        <b>Type:</b> {item.typeOfProperty}
                      </div>
                      <div>
                        <b>Price:</b> R {numberWithSpaces(item.price)}
                      </div>
                      <div>
                        <b>Area:</b> {item?.address?.description}
                      </div>
                    </Box>
                  }
                  arrow
                  placement="top"
                >
                  <span
                    style={{
                      textDecoration: "underline",
                      color: STYLES.SECONDARY_APP_CLR,
                      cursor: "pointer",
                      fontWeight: 500,
                      fontSize: 16
                    }}
                  >
                    {item.web_Ref_No}
                  </span>
                </Tooltip>
              )}
            </div>
          </div>

          {/* Viewed By/New */}
          {!item?.viewedByAdmin ? (
            <p
              className="h6"
              style={{
                color: STYLES.SECONDARY_APP_CLR,
                margin: 0,
                textTransform: "none"
              }}
            >
              NEW
            </p>
          ) : null}

          {/* Broker */}
          <div style={{ margin: 0, color: STYLES.SECONDARY_APP_CLR }}>
            <span
              className="h6"
              style={{ marginRight: 6, textTransform: "none" }}
            >
              Broker:
            </span>
            <span>
              {item?.userdetials.Name || item?.userdetials.lastName
                ? `${item.userdetials.Name} ${item.userdetials.lastName}`
                : "No broker assigned"}
            </span>
          </div>

          {/* Icons and Created At */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 8,
              color: STYLES.SECONDARY_APP_CLR
            }}
          >
            {/* Icons Row */}
            <div style={{ display: "flex", gap: "10px" }}>
              <img
                src={item?.webPublish ? ApiWebIcon : ApiWebGrey}
                alt="API Web"
                style={{ width: 30, height: 30 }}
              />
              {/* <img src={item?.webPublish ? OPIcon : OPIconGrey} alt="OP" style={{ width: 30, height: 30 }} /> */}
              <img
                src={
                  item?.webPublish
                    ? PrivatePropertyIcon
                    : PrivatePropertyGreyIcon
                }
                alt="Private Property"
                style={{ width: 30, height: 30 }}
              />
              <a onClick={onProperty24} style={{ cursor: "pointer" }}>
                <img
                  src={
                    item?.publishedProp24 ? Property24Icon : Property24GreyIcon
                  }
                  alt="Property24"
                  style={{ width: 30, height: 30 }}
                />
              </a>
            </div>
          </div>
        </div>

        {/* Listing Card Menu */}
        <div>
          <UncontrolledDropdown direction={dropUp ? "up" : "down"}>
            <DropdownToggle
              tag="span"
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer"
              }}
            >
              {/* <i className="now-ui-icons design_bullet-list-67" /> */}
              <img
                src={BulletMenuIcon}
                alt="Listing Options"
                style={{ width: 25, height: 25 }}
              />
            </DropdownToggle>

            <DropdownMenu>
              <DropdownItem onClick={() => changeListingToNew(item)}>
                Mark As New
              </DropdownItem>
              <DropdownItem onClick={() => changeListingToViewed(item)}>
                Archive
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  changeListingToViewed(item);
                  navigate("/update", { state: { item } });
                }}
              >
                Update
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  changeListingToViewed(item);
                  navigate("/duplicateListing", { state: { item } });
                }}
              >
                Duplicate
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  setLoading({
                    isloading: true,
                    reason: "Generating Brochure"
                  });
                  dispatch(generatePdfLinks(item?.web_Ref_No));
                }}
              >
                {item.BrochureUrl
                  ? "View Brochure Link"
                  : "Create Brochure Link"}
              </DropdownItem>
              {item.BrochureUrl && (<DropdownItem
                onClick={() => {
                  setLoading({ isloading: true, reason: "Updating Brochure" });
                  dispatch(generatePdfLinks(item?.web_Ref_No));
                }}
              >
                Update Brochure Link
              </DropdownItem>)}
              <DropdownItem
                onClick={() => {
                  changeListingToViewed(item);
                  navigate("/staffpullforwardlisting", { state: { item } });
                }}
              >
                Pull Forward
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  changeListingToViewed(item);
                  navigate("/publish", { state: { item } });
                }}
              >
                Publish
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
    );
  };

  //Function used to display the list of listings using flat list
  function RenderFlatlist() {
    return (
      <FlatList
        keyExtractor={(item, index) => {
          return index.toString();
        }}
        list={displayedListings || []}
        renderOnScroll
        renderItem={(item) => {
          return <RenderItem {...item} />;
        }}
        renderWhenEmpty={() => <div>There currently is no Stock!</div>}
      />
    );
  }

  function RenderTable() {
    const quickEdit = (rowData) => {
      handleEdit(rowData);
    };

    const publishListingTable = (rowData) => {
      navigate("/publish", {
        state: { item: rowData } // Pass rowData as item
      });
    };

    const view = (rowData) => {
      navigate("/stockdetials", {
        state: { item: rowData }
      });
      fetchAllListings();
    };

    const editTable = (rowData) => {
      navigate("/update", {
        state: { item: rowData } // Pass rowData as item
      });
    };

    const getBrochureLinks = (rowData) => {
      showModal(rowData)
    }

    const duplicateListingTable = (rowData) => {
      navigate("/duplicateListing", {
        state: { item: rowData } // Pass rowData as item
      });
    };


    const brochureTable = (rowData) => {
      setLoading({ isloading: true, reason: "Creating Brochure" });
      Brochure(rowData);
    };

    const updateBrochureTable = (rowData) => {
      setLoading({ isloading: true, reason: "Updating Brochure" });
      dispatch(generatePdfLinks(rowData?.web_Ref_No));
    };

    const syncWithWebsite = (rowData) => {
      setLoading({ isloading: true, reason: "Syncing With Website" });
      SyncWithWebsite(rowData);
    };

    const syncWithPrivateProperty = (rowData) => {
      setLoading({ isloading: true, reason: "Syncing With Private Property" });
      SyncWithPrivateProperty(rowData);
    };

    const syncWithProperty24 = (rowData) => {
      setLoading({ isloading: true, reason: "Syncing With Property24" });
      SyncWithProperty24(rowData);
    };

    const api_website_sendTable = (rowData) => {
      alert("You saved " + rowData.name);
    };

    const PrivatePropertysendTable = (rowData) => {
      alert("You saved " + rowData.name);
    };

    const Property_24 = (rowData) => {
      alert("You saved " + rowData.name);
    };

    const handleAdd = () => {
      dispatch(clearListingErrors());
      navigate('/createStock')
    };

    return (
      <Material_React_Table
        data={displayedListings}
        allData={filteredListings.length > 0 ? filteredListings : currentListings}
        columns={columns}
        userInitialState={{
          columnVisibility: { id: false }, // This hides the "id" column initially
          pagination: { pageSize: 10 },
        }}
        view={view}
        onRowUpdate={quickEdit}
        publish={publishListingTable}
        duplicate={duplicateListingTable}
        api={api_website_sendTable}
        PrivateProperty={PrivatePropertysendTable}
        property24={Property_24}
        editTable={editTable}
        brochureTable={getBrochureLinks}
        updateBrochureTable={updateBrochureTable}
        syncWithWebsite={syncWithWebsite}
        syncWithPrivateProperty={syncWithPrivateProperty}
        syncWithProperty24={syncWithProperty24}
        handleAdd={handleAdd}
      />
    );
  }

  //Return of Screen
  return loading.isloading || listingManagementReducer.loading ? (
    <CircularLoading label={loading.reason} />
  ) : (
    <div style={styles.container}>
      <div style={styles.filter}>
        <CustomAdvanceListingsFilter
          setView={setView}
          filteredListings={filteredListings}
          setFilteredListings={setFilteredListings}
          setDisplayedListings={setDisplayedListings}
          currentListings={currentListings.sort((a, b) => {
            const normalize = (value) => {
              if (typeof value === "number") {
                // Already a Unix timestamp in milliseconds
                return value;
              } else if (typeof value === "string") {
                // Parse string with moment
                return moment(value, [
                  "DD MMM YYYY HH:mm",
                  moment.ISO_8601
                ]).valueOf();
              }
              return 0; // Fallback
            };

            const newA = normalize(a.CreatedAt);
            const newB = normalize(b.CreatedAt);

            return newB - newA; // Sort descending
          })}
        />{" "}
      </div>

      {/* //pop-up for the brochure link */}
      {link && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
              textAlign: "center",
              maxWidth: "90%"
            }}
          >
            <p style={{ marginBottom: "12px", fontWeight: "500" }}>
              Here’s your brochure link:
            </p>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "blue",
                textDecoration: "underline",
                wordBreak: "break-all"
              }}
            >
              {link}
            </a>

            <div style={{ marginTop: "16px" }}>
              <button
                onClick={copyToClipboard}
                style={{
                  marginRight: "8px",
                  padding: "6px 12px",
                  background: "black",
                  color: "white",
                  borderRadius: "4px"
                }}
              >
                Copy
              </button>
              <button
                onClick={() => setLink(null)}
                style={{
                  padding: "6px 12px",
                  background: "black",
                  color: "white",
                  borderRadius: "4px"
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={styles.listingsContainer}>
        {" "}
        {view === "list" && <RenderFlatlist />}{" "}
      </div>

      <div style={styles.listingsTable}>
        {" "}
        {view === "table" && <RenderTable />}{" "}
      </div>

      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        action={
          <MuiButton color="secondary" size="small" onClick={handleUndo}>
            UNDO
          </MuiButton>
        }
        onClose={handleSnackbarClose}
        autoHideDuration={12000}
      />
      <ShareListingBrochureModal
        modalVisible={modalVisible}
        hideModal={hideModal}
        item={modalItem}
        selectedOption={modalResult}
        setSelectedOption={(option) => { }}
        //generatePDF={generatePDF}
      />

      {/* Display result */}
      {modalResult && modalResult !== 'cancelled' && (
        <div style={{
          padding: '15px',
          backgroundColor: '#f0f8ff',
          borderRadius: '5px',
          marginTop: '20px'
        }}>
          <p style={{ margin: '0 0 10px 0' }}>
            <strong>Last selected option:</strong> {modalResult}
          </p>
          <button
            onClick={clearResult}
            style={{
              padding: '5px 15px',
              backgroundColor: '#666',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            Clear Result
          </button>
        </div>
      )}
    </div>
  );
};

export default StaffListings;
